<div class="l_flex guts-p-b-1 price-range">
  <div class="l_flex l_flex-column">
    <div class="filter--title h4 guts-p-b-half">
      {{ 'Core_' + minFilter.title | translate }}
    </div>
    <div class="l_flex price-range--container">
      <span>
        <div class="currency-prefix h4">$</div>
      </span>
      <input
        #minPriceInput
        class="guts-p-b-half price-range"
        [attr.aria-label]="'Core_' + minFilter.title | translate"
        [value]="minCostValue"
        data-dgat="search-filter-sidebar-range-options-aa0"
        role="spinbutton"
        type="number"
      />
    </div>
  </div>
  <div class="l_flex l_flex-column">
    <div class="filter--title h4 guts-p-b-half">
      {{ 'Core_' + maxFilter.title | translate }}
    </div>
    <div class="l_flex price-range--container">
      <span>
        <div class="currency-prefix h4">$</div>
      </span>
      <input
        #maxPriceInput
        [attr.aria-label]="'Core_' + maxFilter.title | translate"
        [value]="maxCostValue"
        data-dgat="search-filter-sidebar-range-options-a2d"
        role="spinbutton"
        type="number"
      />
    </div>
  </div>
</div>
